var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2221",
    x: 20,
    y: 13,
    width: 200,
    height: 202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2225",
    x: 0,
    y: 0,
    width: 228,
    height: 228,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(-73 -156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73, 156)",
    filter: "url(#Rectangle_2221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2221-2",
    "data-name": "Rectangle 2221",
    width: 182,
    height: 184,
    rx: 91,
    transform: "translate(23 16)",
    fill: "#fe6502"
  })), /*#__PURE__*/React.createElement("g", {
    id: "photo_camera-24px",
    transform: "translate(128.5 205.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M0,0H117V117H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 15.635,
    cy: 15.635,
    r: 15.635,
    transform: "translate(42.865 42.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M36.109,2l-8.917,9.772H11.746A9.788,9.788,0,0,0,2,21.544V80.177a9.788,9.788,0,0,0,9.746,9.772H89.71a9.788,9.788,0,0,0,9.746-9.772V21.544a9.788,9.788,0,0,0-9.746-9.772H74.263L65.346,2ZM50.728,75.291a24.431,24.431,0,1,1,24.364-24.43A24.406,24.406,0,0,1,50.728,75.291Z",
    transform: "translate(7.772 7.772)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73, 156)",
    filter: "url(#Rectangle_2225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2225-2",
    "data-name": "Rectangle 2225",
    transform: "translate(9 3)",
    fill: "none",
    stroke: "#fe6502",
    strokeWidth: 1,
    opacity: 0.601
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 210,
    rx: 105,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 209,
    height: 209,
    rx: 104.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddObject);
export default __webpack_public_path__ + "static/media/add-object.cfc8205ac26aa0e14c20080db9872ca7.svg";
export { ForwardRef as ReactComponent };